{
  "brand": {
    "tagline": "All your favourite shops, one membership."
  },
  "common": {
    "continue": "Continue",
    "cancel": "Cancel",
    "close": "Close",
    "done": "Done",
    "retry": "Try again",
    "save": "Save",
    "edit": "Edit",
    "publish": "Publish",
    "search": "Search",
    "learnMore": "Learn more",
    "notAvailable": "Not available",
    "offline": "Offline",
    "updated": "Updated {time}"
  },
  "tabs": {
    "home": "Home",
    "explore": "Explore",
    "activity": "Activity",
    "profile": "Profile"
  },
  "home": {
    "greeting": "Good afternoon",
    "title": "Your rewards",
    "showCard": "Show my card",
    "createCard": "Create card",
    "noCard": "No card yet",
    "createCardBody": "Create a free universal card to start collecting.",
    "rewardReady": "Reward ready",
    "inProgress": "In progress",
    "nearby": "Explore nearby",
    "emptyTitle": "Start collecting",
    "emptyBody": "Show your Collectie card at a partner shop to begin.",
    "stale": "Showing the last saved update while offline"
  },
  "card": {
    "universal": "One card · every shop",
    "title": "Your Collectie card",
    "member": "Member",
    "memberCode": "Member {code}",
    "scanHint": "Ask the cashier to scan this card.",
    "wallet": "Open in Apple Wallet",
    "lastRefresh": "Last refreshed {time}",
    "brightness": "Screen brightness is temporarily increased while this card is open.",
    "codeUnavailable": "No scannable code yet. Show the member code above to staff.",
    "preparing": "Preparing your card…"
  },
  "membership": {
    "eyebrow": "Your progress",
    "stamps": "Stamps",
    "progress": "{current} of {target} stamps",
    "progressTitle": "Stamp progress",
    "nextReward": "Next reward",
    "availableRewards": "Available rewards",
    "recentActivity": "Recent activity",
    "terms": "Program terms",
    "website": "Visit shop website",
    "joined": "Joined {date}",
    "oneMore": "One more stamp to go",
    "rewardReady": "Your reward is ready"
  },
  "reward": {
    "available": "Available",
    "redeemed": "Redeemed",
    "expired": "Expired",
    "redeemAtCounter": "Redeem with a cashier",
    "validUntil": "Valid until {date}"
  },
  "boost": {
    "unlockTitle": "Unlock an App Boost",
    "unlockBody": "Connect the Collectie app and get one extra stamp on your next eligible purchase here.",
    "pendingTitle": "App Boost ready",
    "pendingBody": "Your next eligible purchase includes one extra stamp.",
    "applied": "App Boost applied",
    "expired": "App Boost expired",
    "reversed": "App Boost reversed",
    "validUntil": "Use by {date}"
  },
  "explore": {
    "eyebrow": "Collect around you",
    "title": "Explore partners",
    "searchPlaceholder": "Coffee, lunch, flowers…",
    "nearYou": "Near you",
    "newPartners": "New partners",
    "all": "All",
    "coffee": "Cafés & tea",
    "food": "Food",
    "shops": "Shops",
    "locationPrompt": "Allow location to sort nearby partners.",
    "noLocation": "You can still browse every partner without sharing your location.",
    "viewMode": "Explore view",
    "map": "Map",
    "list": "List",
    "loading": "Loading partner locations…",
    "emptyTitle": "No partner locations yet",
    "emptyBody": "New locations will appear here after their loyalty program is published.",
    "errorTitle": "Could not load partners",
    "errorBody": "Check your connection and try again.",
    "offline": "Showing saved partner locations while offline",
    "locate": "Locate me",
    "locationDeniedTitle": "Location is off",
    "yourLocation": "Your location",
    "viewShop": "View shop",
    "website": "Visit website",
    "reward": "Loyalty reward",
    "location": "Location",
    "openInMaps": "Open in Maps",
    "stampGoal": "Stamp goal",
    "clearSearch": "Clear search"
  },
  "activity": {
    "eyebrow": "Your story",
    "title": "Activity",
    "earn": "Stamp earned",
    "bonus": "App Boost applied",
    "rewardIssued": "Reward unlocked",
    "redeem": "Reward redeemed",
    "adjustment": "Balance adjusted",
    "reversal": "Transaction reversed",
    "expiry": "Reward expired",
    "empty": "Your Collectie activity will appear here.",
    "emptyTitle": "No activity yet",
    "errorTitle": "Activity unavailable",
    "errorBody": "Check your connection and try again.",
    "loading": "Loading activity…",
    "loadMore": "Load earlier activity",
    "loadingMore": "Loading earlier activity…"
  },
  "profile": {
    "eyebrow": "Made yours",
    "title": "Profile",
    "account": "Account",
    "provisional": "Rewards are not yet protected",
    "protected": "Your rewards are protected",
    "protect": "Protect your rewards",
    "signInApple": "Continue with Apple",
    "wallet": "Apple Wallet card",
    "replaceCard": "Replace card",
    "language": "Language",
    "languageSystem": "Use iPhone app language",
    "serverLocale": "Pass and message language",
    "privacy": "Privacy and data",
    "export": "Request data export",
    "delete": "Delete account",
    "deleteTitle": "Delete your Collectie account?",
    "deleteBody": "Your card will stop working, memberships will close, and the Apple Wallet pass will be removed from this iPhone. Transaction history may be retained in pseudonymous form for audit and fraud prevention.",
    "deleteConfirm": "Delete account",
    "deleting": "Deleting account…",
    "deleteFailed": "We could not delete your account. Your card still works; please try again.",
    "browsing": "Browsing without a card",
    "memberCode": "Collectie card",
    "privacyIntro": "Collectie uses only the data needed to operate your universal card and each shop's separate loyalty program.",
    "privacyIdentifiersTitle": "Card and device identifiers",
    "privacyIdentifiersBody": "We store an opaque person ID, card credential, and a hashed app-installation identifier so your card can be recognized securely. Raw credentials stay in this iPhone's Keychain and are never logged.",
    "privacyRewardsTitle": "Membership and purchase activity",
    "privacyRewardsBody": "We store shop memberships, stamps, rewards, and verified loyalty transactions. Each merchant can see only activity for its own shop.",
    "privacyLocationTitle": "Location",
    "privacyLocationBody": "Location is optional, requested only after you tap Locate me, and used on this iPhone to sort nearby shops. It is not sent to Collectie.",
    "privacyTrackingTitle": "No advertising tracking",
    "privacyTrackingBody": "Collectie does not use advertising trackers, sell personal data, or combine your activity across merchants for advertising.",
    "privacyRetentionTitle": "Deletion and retention",
    "privacyRetentionBody": "Deleting your account revokes credentials and pseudonymizes direct identifiers. Immutable transaction records may be retained where needed for audit, fraud prevention, and legal obligations.",
    "privacyPolicy": "Read the full privacy policy",
    "support": "Help and support",
    "version": "Version {version}",
    "versionLabel": "Version",
    "pilotUnavailable": "Not available in this pilot build yet."
  },
  "onboarding": {
    "eyebrow": "Your loyalty, collected",
    "checkingBody": "Checking this iPhone for an accessible Collectie card.",
    "checkingTitle": "Looking for your card",
    "connecting": "Connecting rewards…",
    "connectingBody": "Keep the app open while we securely bring over your memberships.",
    "createCard": "Create my Collectie card",
    "creatingCard": "Creating your card…",
    "createCardFailed": "We could not create your card. Check your connection and try again.",
    "cardStartsEmpty": "Your card starts empty. A shop membership begins only when you use it at that shop.",
    "checkWalletAgain": "Check Apple Wallet again",
    "browseFirst": "Explore without a card",
    "continueWithoutCard": "Continue without linking",
    "errorBody": "Your rewards were not changed. Check your connection and try again.",
    "errorTitle": "Could not connect your card",
    "foundTitle": "Welcome back",
    "foundBody": "We found your Collectie card and existing rewards.",
    "connect": "Connect this card",
    "noCardTitle": "Start with Collectie",
    "noCardBody": "Create a card now or protect rewards you already have.",
    "noManualEntry": "No member number to enter",
    "protectExisting": "Protect existing rewards",
    "separateShops": "Each shop keeps its own rewards",
    "skip": "Not now",
    "valuePreserved": "Existing balances stay unchanged"
  },
  "join": {
    "eyebrow": "Wallet-first rewards",
    "title": "Collect rewards at {merchant}",
    "noApp": "No app needed.",
    "noPii": "No email or account is required before your card.",
    "body": "Save your Collectie card to Apple Wallet and use it at every partner shop.",
    "addWallet": "Add to Apple Wallet",
    "alreadyMember": "Already have Collectie? Open your card.",
    "privacy": "By continuing, you agree to the loyalty terms and acknowledge the privacy notice.",
    "protectTitle": "Your card is ready",
    "protectBody": "Install Collectie to protect your rewards and explore every partner.",
    "getApp": "Get the Collectie app",
    "program": "Collect {target} stamps and receive a reward.",
    "creating": "Creating your card…",
    "added": "Card ready",
    "membershipReady": "Membership ready",
    "actionError": "We could not prepare your membership. No purchase or reward was added. Try again.",
    "fallback": "Some shop content is shown in English.",
    "stampsToReward": "stamps to reward",
    "perPurchase": "per verified purchase",
    "reward": "Your reward",
    "previewLabel": "Your universal membership card",
    "previewTitle": "One card for every Collectie shop",
    "atThisShop": "At this shop",
    "merchantWebsite": "Visit shop website",
    "programDetails": "What you’ll collect here",
    "terms": "Loyalty terms",
    "safeJoin": "This code joins or opens membership. Purchases are confirmed separately at checkout.",
    "loading": "Loading shop rewards…",
    "loadErrorTitle": "We could not load this shop",
    "loadErrorBody": "No membership or value was created. Check your connection and try again.",
    "notFoundTitle": "This shop is not available",
    "notFoundBody": "The location or loyalty program may be paused. Ask the shop for its current Collectie code."
  },
  "merchant": {
    "auth": {
      "eyebrow": "Merchant access",
      "title": "Sign in to Collectie",
      "body": "Manage your loyalty program and keep checkout moving from one secure workspace.",
      "formLabel": "Merchant sign-in",
      "noPasswordTitle": "No password to remember",
      "noPasswordBody": "We send a short-lived code to your approved merchant email.",
      "email": "Work email",
      "emailTitle": "Continue with email",
      "emailHelp": "Use the email your owner or manager invited.",
      "sendCode": "Send sign-in code",
      "sending": "Sending code…",
      "code": "Six-digit code",
      "codeTitle": "Check your inbox",
      "codeHelp": "Enter the code sent to {email}.",
      "localCode": "Local test code: {code}",
      "verify": "Verify and continue",
      "verifying": "Verifying…",
      "changeEmail": "Use a different email",
      "requestError": "We could not send a code. Check the address and try again.",
      "verifyError": "That code could not be verified. Check it and try again.",
      "accessCodeTitle": "Use an access code",
      "accessCodeBody": "Enter the access code issued for this merchant workspace.",
      "accessCode": "Access code",
      "accessCodeContinue": "Continue",
      "accessCodeSigningIn": "Opening workspace…",
      "accessCodeError": "That access code was not accepted. Check it and try again.",
      "useEmailCode": "Use email code instead",
      "useAccessCode": "Use an access code",
      "openTill": "Open this till",
      "signOut": "Sign out",
      "signingOut": "Signing out…",
      "signOutError": "We could not sign you out. Retry before leaving this device.",
      "emailOtpSubject": "Your Collectie sign-in code",
      "emailOtpLead": "Your Collectie sign-in code is {code}.",
      "emailOtpExpiry": "This code expires in 5 minutes.",
      "emailOtpIgnore": "If you did not request this code, you can ignore this email."
    },
    "operator": {
      "eyebrow": "Pilot operations",
      "title": "Onboard a shop",
      "body": "Create the merchant, first location, and owner access in one audited operation. The loyalty program is configured after the owner signs in.",
      "accessEyebrow": "Protected operation",
      "accessTitle": "Operator access",
      "accessBody": "Use the staging or production key issued to an approved Collectie operator. It is sent only with this request and is never stored by the browser.",
      "operatorKey": "Operator onboarding key",
      "shopEyebrow": "Merchant identity",
      "shopTitle": "Shop details",
      "merchantNameEn": "Shop name — English",
      "merchantNameZhHant": "Shop name — Traditional Chinese (optional)",
      "legalName": "Legal name",
      "merchantSlug": "Merchant slug",
      "currency": "Currency code",
      "category": "Discovery category",
      "categoryCafeTea": "Cafés & tea",
      "categoryFood": "Food",
      "categoryShops": "Shops",
      "ownerEyebrow": "Account owner",
      "ownerTitle": "Owner access",
      "ownerName": "Owner name",
      "ownerEmail": "Owner email",
      "ownerLocale": "Preferred language",
      "locationEyebrow": "First public location",
      "locationTitle": "Location and map details",
      "locationNameEn": "Location name — English",
      "locationNameZhHant": "Location name — Traditional Chinese (optional)",
      "locationInternalName": "Internal location name",
      "locationSlug": "Permanent join URL slug",
      "address": "Street address",
      "locality": "City",
      "region": "Region (optional)",
      "postalCode": "Postal code",
      "countryCode": "Country code",
      "timezone": "Timezone",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "authorizationError": "The operator key was not accepted. No shop was created.",
      "submitError": "The shop could not be created. Check every field, then retry the same request.",
      "submitNote": "This creates one active shop, one active owner, and one geocoded location. It does not publish a loyalty program or award value.",
      "submit": "Create pilot shop",
      "submitting": "Creating pilot shop…",
      "completeEyebrow": "Shop created",
      "completeTitle": "Owner onboarding can begin",
      "completeBody": "{email} can now request a secure sign-in code and publish the first loyalty program.",
      "joinUrl": "Permanent join URL",
      "openSignIn": "Open merchant sign-in"
    },
    "shell": {
      "loading": "Restoring your secure session…",
      "connectionLabel": "Connection",
      "unavailableTitle": "We could not load your workspace",
      "unavailableBody": "No changes were made. Check your connection and retry.",
      "managementNavigation": "Merchant management",
      "backToOverview": "Back to overview",
      "locationCount": "Active locations: {count}",
      "sectionPending": "This management area is the next thin slice. Your current merchant data remains unchanged."
    },
    "nav": {
      "overview": "Home",
      "program": "Loyalty",
      "shop": "Shop profile",
      "locations": "Locations",
      "staff": "Team & tills",
      "transactions": "Activity",
      "campaigns": "Campaigns",
      "settings": "Settings",
      "scanner": "Scanner",
      "dashboard": "Overview",
      "activity": "Transactions"
    },
    "overview": {
      "welcome": "Good to see you, {name}",
      "title": "Today at a glance",
      "transactions": "Transactions",
      "newMembers": "New members",
      "rewardsRedeemed": "Rewards redeemed",
      "appBoosts": "App Boosts",
      "recent": "Recent activity"
    },
    "pageDescription": {
      "overview": "A clear view of today, your loyalty program, and anything that needs attention.",
      "transactions": "Review verified checkout activity and correct eligible transactions.",
      "program": "Shape the loyalty experience your customers see at every shop.",
      "shop": "Keep your identity consistent across joining, Wallet, and the Collectie app.",
      "locations": "Manage shop details and the public QR that starts membership.",
      "staff": "Control who can manage the business and which counters can run checkout."
    },
    "till": {
      "open": "Open till",
      "openHint": "Shared checkout",
      "checkingDevice": "Checking till",
      "sharedCounter": "Anonymous shared counter",
      "menu": "Till options",
      "manageBusiness": "Manage business"
    },
    "program": {
      "title": "Loyalty program",
      "draft": "Draft",
      "active": "Active",
      "visitTemplate": "Visit stamps",
      "itemTemplate": "Item-group stamps",
      "threshold": "Stamps required",
      "rewardLabel": "Reward",
      "dailyLimit": "Daily earn limit",
      "expiry": "Reward expiry",
      "preview": "Preview customer view",
      "publishConfirm": "Publish this version? Existing transactions keep their original terms.",
      "type": "Program type",
      "target": "Stamps required",
      "reward": "Reward",
      "appBoost": "App Boost",
      "appBoostDescription": "Add one bonus stamp on the next verified purchase after app activation.",
      "templateHeading": "Choose a safe template",
      "visitHelp": "Award stamps for verified eligible visits.",
      "itemHelp": "Award stamps only for controlled item groups.",
      "englishContent": "English content",
      "chineseContent": "Traditional Chinese content",
      "optional": "Optional",
      "name": "Program name",
      "description": "Description",
      "terms": "Terms",
      "itemGroups": "Eligible item groups",
      "addItemGroup": "Add item group",
      "itemKey": "Internal key",
      "itemEnglish": "English label",
      "itemChinese": "Traditional Chinese label",
      "removeItemGroup": "Remove item group",
      "fallbackPreview": "English fallback",
      "fallbackWarning": "Traditional Chinese is empty. English will be shown to customers.",
      "history": "Version history",
      "version": "Version {version}",
      "publishedThreshold": "Published stamp threshold",
      "noHistory": "No version has been published yet.",
      "previewName": "Untitled program",
      "loading": "Loading program draft…",
      "loadError": "We could not load this program. No changes were made.",
      "permissionTitle": "Program access unavailable",
      "permissionBody": "An owner or globally scoped manager must manage this program.",
      "unsaved": "Unsaved changes",
      "saving": "Saving…",
      "saved": "Draft saved.",
      "published": "A new immutable version is active.",
      "saveError": "The draft could not be saved. Review the fields and retry.",
      "publishError": "The draft could not be published. Refresh the draft and retry.",
      "publishTitle": "Publish a new version?",
      "validationRequired": "This field is required.",
      "validationFormat": "Use the required safe format.",
      "validationDuplicate": "This value must be unique.",
      "validationLength": "This content is too long.",
      "validationRange": "Use a value within the allowed range."
    },
    "scanner": {
      "title": "Scan customer",
      "ready": "Ready to scan",
      "cameraHelp": "Place the Collectie barcode inside the frame.",
      "addStamp": "Add 1 stamp",
      "redeem": "Redeem reward",
      "success": "Transaction complete",
      "duplicate": "Already completed — showing the original result.",
      "permissionTitle": "Camera access needed",
      "permissionBody": "Allow camera access in browser settings or use the approved support fallback.",
      "offlineTitle": "Connection lost",
      "offlineBody": "No reward was added. Reconnect and retry the same action.",
      "start": "Open scanner",
      "prompt": "Scan the customer’s Collectie card",
      "hint": "Keep this device paired to the correct location. No transaction is created until a cashier confirms the action.",
      "manual": "Use approved fallback",
      "deviceScope": "Paired checkout device",
      "deviceChecking": "Checking this checkout device…",
      "deviceCheckingBody": "The scanner opens only after this browser has a paired credential.",
      "deviceCheckError": "We could not check this device",
      "pairTitle": "Pair this checkout device",
      "pairBody": "Enter the one-time code created by an authorized manager. The device credential stays protected from browser scripts.",
      "pairingCode": "One-time pairing code",
      "pairHelp": "Codes contain 8 letters or numbers and expire after 10 minutes.",
      "pairError": "That code is invalid, expired, or already used. No device was paired.",
      "pairing": "Pairing device…",
      "pairAction": "Pair device",
      "checking": "Checking customer",
      "noValueYet": "No stamp or reward has been added.",
      "cardUnknownTitle": "Card not recognized",
      "cardUnknownBody": "Ask the customer to open their current Collectie card, then scan again.",
      "quoteExpiredTitle": "Confirmation expired",
      "quoteExpiredBody": "No value was added. Scan the customer card again for a fresh confirmation.",
      "actionErrorTitle": "Action unavailable",
      "actionErrorBody": "No value was added. Check the card and device, then try again.",
      "scanAgain": "Scan again",
      "confirmLabel": "Confirm customer",
      "currentBalance": "Current stamp balance",
      "quoteWindow": "This confirmation is short-lived. The balance changes only after you confirm.",
      "confirmEarn": "Confirm +{quantity} stamp",
      "committing": "Adding stamp…",
      "commitPending": "Keep this page open. The same secure request will be used if a retry is needed.",
      "retrySameAction": "Retry same action",
      "balanceNow": "{balance} stamps now",
      "earnedReceipt": "+{quantity} added from the authoritative ledger.",
      "earnedRewardReceipt": "+{quantity} stamp added. A reward is now unlocked and ready to use.",
      "nextCustomer": "Scan next customer",
      "cameraStarting": "Starting camera",
      "cameraIdle": "Camera paused",
      "cameraUnavailableBody": "Live QR scanning is unavailable here. Use the approved fallback to follow the same secure confirmation flow.",
      "enableCamera": "Enable camera",
      "manualLabel": "Customer card credential",
      "manualHelp": "Paste only from the approved support flow. It is cleared immediately after checking.",
      "checkCustomer": "Check customer",
      "availableRewards": "Available rewards",
      "rewardReady": "Ready to use",
      "confirmRedeem": "Confirm redemption",
      "rewardStaleTitle": "Reward changed",
      "rewardStaleBody": "No reward was redeemed. Scan again to load the customer’s current rewards.",
      "rewardRedeemed": "Reward redeemed",
      "redeemedReceipt": "The authoritative ledger recorded this redemption.",
      "addStampFor": "Add stamp for {item}",
      "confirmEarnItem": "Add {quantity} stamp · {item}",
      "chooseItemGroup": "Which item?",
      "dailyLimitReached": "Today’s limit of {limit} stamps at this shop is used up. Rewards can still be redeemed."
    },
    "staff": {
      "title": "Team & tills",
      "managementAccess": "Management access stays personal",
      "managementAccessBody": "Owners and managers sign in with their own email or access code. Counter staff use the paired till without entering the management workspace.",
      "tillsEyebrow": "Checkout access",
      "tillsTitle": "Paired tills",
      "tillsBody": "Each till is an anonymous shared counter tied to one shop location. Its device name appears in every checkout record.",
      "activeCount": "{count} active",
      "loadingDevices": "Loading paired tills…",
      "devicesError": "We could not load paired tills. No device settings were changed.",
      "emptyTills": "No tills paired yet",
      "emptyTillsBody": "Create a one-time code below, then enter it on the checkout device.",
      "neverUsed": "Not opened yet",
      "lastSeen": "Last opened {time}",
      "status": {
        "active": "Active",
        "revoked": "Revoked"
      },
      "revokeConfirm": "This till will stop working immediately.",
      "revokeAction": "Revoke till",
      "revokeError": "We could not revoke this till. It may still be able to check out customers.",
      "pairEyebrow": "Add a counter",
      "invite": "Invite staff",
      "pair": "Pair checkout device",
      "pairBody": "Name the counter and create a short-lived code. Enter it once on the device to give that browser checkout access for the selected location.",
      "deviceLabel": "Checkout device name",
      "deviceLabelHelp": "Use a name staff will recognize, such as Front counter iPhone.",
      "createCode": "Create one-time code",
      "creatingCode": "Creating code…",
      "codeTitle": "One-time pairing code",
      "codeBody": "Enter this code once in Open till. It expires after ten minutes and cannot be reused.",
      "expiresAt": "Expires {time}",
      "copyCode": "Copy code",
      "copied": "Code copied",
      "generateAnother": "Create another code",
      "createError": "The code could not be created. No device was paired. Check the location and retry.",
      "noLocations": "Add or activate a location before pairing a checkout device.",
      "revoke": "Revoke",
      "owner": "Owner",
      "manager": "Manager",
      "cashier": "Cashier"
    },
    "dashboard": {
      "title": "Overview",
      "statusLabel": "Business status",
      "glance": "Today at a glance",
      "todayTransactions": "Transactions today",
      "activeMembers": "Active members",
      "rewardsRedeemed": "Rewards redeemed",
      "programLive": "Published and earning at all active locations.",
      "recent": "Recent activity",
      "loading": "Loading today’s overview…",
      "errorTitle": "We could not load the overview",
      "errorBody": "No data was changed. Check your connection and try again.",
      "permissionTitle": "Overview unavailable",
      "permissionBody": "Your current merchant role cannot view this overview.",
      "localToday": "Location-local today",
      "serverTruth": "Active server records",
      "programPublished": "Published program",
      "programDraft": "Program setup",
      "checkoutReady": "Ready for checkout",
      "setupRequired": "Setup needs attention",
      "programNotPublished": "Publish your first loyalty program",
      "programThreshold": "Collect {threshold}; public joining is ready at {ready} of {active} active locations.",
      "publishPrompt": "Finish and publish the program before displaying a public join QR.",
      "emptyTitle": "No verified activity yet",
      "emptyBody": "Confirmed checkout events will appear here."
    },
    "shop": {
      "title": "Shop profile",
      "loading": "Loading your shop profile…",
      "errorTitle": "We could not load your shop profile",
      "errorBody": "No shop detail was changed. Check your connection and try again.",
      "permissionTitle": "Shop profile unavailable",
      "permissionBody": "Your current merchant role cannot view this shop profile.",
      "identityEyebrow": "Customer-facing identity",
      "identityTitle": "Make this unmistakably your shop",
      "identityBody": "These details appear when a customer joins, opens their membership, or discovers your shop in Collectie.",
      "chooseLogo": "Choose logo",
      "logoHelp": "PNG, JPEG, or WebP. Square artwork works best; maximum 512 KB.",
      "logoSave": "Upload this logo",
      "logoSaving": "Uploading logo…",
      "logoError": "The logo could not be uploaded. Check the file type and size, then try again.",
      "english": "English",
      "traditionalChinese": "Traditional Chinese (optional)",
      "displayName": "Shop name",
      "description": "Short description",
      "category": "Shop category",
      "categories": {
        "cafe_tea": "Café & tea",
        "food": "Food",
        "shops": "Shops"
      },
      "website": "Website (optional)",
      "brandColor": "Brand colour",
      "customerPreview": "Customer preview",
      "previewFallback": "Your shop",
      "previewDescriptionFallback": "A short introduction helps customers recognise this membership.",
      "previewWallet": "Add to Apple Wallet",
      "previewSurfaces": "A compact preview of the identity used on join pages and in the Collectie app. Wallet layout follows Apple’s pass format.",
      "qrEyebrow": "Public join QR",
      "qrTitle": "Style it without making it fragile",
      "qrBody": "The permanent destination stays unchanged. Styling is applied to every location QR.",
      "qrPreviewAlt": "Preview of the styled public join QR",
      "qrPreviewError": "This colour combination is not scan-safe. Increase the contrast and keep the foreground darker.",
      "qrForeground": "QR colour",
      "qrBackground": "Background",
      "qrShape": "Dot shape",
      "qrStyles": {
        "square": "Square",
        "rounded": "Rounded",
        "dots": "Dots"
      },
      "qrLogo": "Place logo in the centre",
      "qrLogoHelp": "Available after a logo is uploaded.",
      "qrGuardrail": "Collectie keeps a quiet zone, strong contrast, high error correction, and a bounded logo area so the QR remains dependable.",
      "validation": "Check the required English name, HTTPS website, descriptions, and scan-safe QR colours.",
      "saveError": "The profile could not be saved. No unknown change was applied; reconnect and try again.",
      "readOnly": "Only owners and managers can change the shop profile.",
      "saving": "Saving profile…",
      "save": "Save shop profile",
      "saved": "Shop profile saved. Customer surfaces will use the new identity."
    },
    "locations": {
      "eyebrow": "Shop locations",
      "title": "Locations and public QR",
      "body": "Each location has one permanent public join QR. Download it for the counter, window, menu, or printed material.",
      "loading": "Loading locations…",
      "errorTitle": "We could not load locations",
      "errorBody": "No location was changed. Check your connection and try again.",
      "permissionTitle": "Locations unavailable",
      "permissionBody": "Your current merchant role cannot view these locations.",
      "add": "Add location",
      "newEyebrow": "New pilot location",
      "newTitle": "Location details",
      "internalName": "Internal name",
      "slug": "Permanent URL slug",
      "displayNameEn": "Display name — English",
      "displayNameZhHant": "Display name — Traditional Chinese (optional)",
      "addressLine1": "Street address",
      "addressLine2": "Address line 2 (optional)",
      "locality": "City",
      "region": "Region (optional)",
      "postalCode": "Postal code",
      "countryCode": "Country code",
      "timezone": "Timezone",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "coordinate": "Map coordinate",
      "coordinateHelp": "Coordinates locate this shop in the future map view. They do not grant transaction authority.",
      "validation": "Check the URL slug, address, coordinates, and required English display name.",
      "conflict": "That location or URL already exists. Nothing was created.",
      "saveError": "The result is unknown. Reconnect and retry the same location request.",
      "retrySame": "Retry same location",
      "saving": "Creating location…",
      "save": "Create location",
      "created": "The location was created with an auditable permanent join URL.",
      "emptyTitle": "No locations yet",
      "emptyBody": "Add the first pilot location to prepare a permanent public join URL.",
      "qrTitle": "Permanent public QR",
      "publicReady": "Public join is ready",
      "publicPending": "Publish the program before displaying this QR",
      "qrSafety": "This QR opens the public join flow only. It cannot add stamps or redeem a reward.",
      "customizeQr": "Customise style",
      "qrPreviewAlt": "Public join QR for {name}",
      "qrPreviewLoading": "Preparing QR…",
      "downloadQr": "Download QR",
      "qrError": "The QR could not be downloaded. Try again.",
      "status": {
        "draft": "Draft",
        "active": "Active",
        "suspended": "Suspended",
        "closed": "Closed"
      }
    },
    "activity": {
      "title": "Transaction activity",
      "recent": "Recent transactions",
      "loading": "Loading transaction activity…",
      "loadErrorTitle": "We could not load activity",
      "loadErrorBody": "No history was changed. Check your connection and try again.",
      "permissionTitle": "Activity unavailable",
      "permissionBody": "Your current merchant role cannot view this activity.",
      "emptyTitle": "No transaction activity yet",
      "emptyBody": "Verified checkout events will appear here.",
      "count": "{count} records",
      "rewardEffect": "Reward",
      "details": "Audit details",
      "actor": "Operator",
      "device": "Checkout device",
      "requestId": "Request ID",
      "sharedTillActor": "Shared till",
      "systemActor": "Collectie system",
      "reverses": "Reverses transaction",
      "reversedBy": "Reversed by transaction",
      "reverseAction": "Reverse transaction",
      "reversalReason": "Reason for reversal",
      "reversalWarning": "This creates linked compensating ledger entries. It does not delete the original transaction.",
      "confirmReversal": "Confirm reversal",
      "reversing": "Creating compensating records…",
      "reversalComplete": "The transaction was reversed with linked compensating records.",
      "reversalForbidden": "Your role cannot reverse this transaction.",
      "reversalConflict": "This transaction is no longer reversible. Activity has not been changed.",
      "reversalOffline": "The result is unknown. Reconnect and retry the same reversal.",
      "reversalError": "The reversal could not be completed. Retry the same action.",
      "retryReversal": "Retry same reversal",
      "loadMore": "Load older activity",
      "loadingMore": "Loading older activity…",
      "action": {
        "earn": "Stamp earned",
        "redeem": "Reward redeemed",
        "adjust": "Adjustment",
        "expire": "Expiry",
        "reverse": "Reversal"
      },
      "status": {
        "committed": "Committed",
        "reversed": "Reversed",
        "voided": "Voided"
      },
      "reason": {
        "cashier_mistake": "Cashier mistake",
        "refund": "Refund",
        "duplicate": "Duplicate transaction",
        "customer_dispute": "Customer dispute",
        "operator_correction": "Operator correction"
      }
    }
  },
  "transaction": {
    "quoteExpired": "This quote expired. Scan the card again.",
    "cardUnknown": "This Collectie card could not be read.",
    "cardRevoked": "This card was replaced or revoked.",
    "rewardUnavailable": "This reward is no longer available.",
    "reversalReason": "Reason for reversal",
    "reversed": "The transaction was reversed.",
    "walletDelayed": "The transaction is complete. The Wallet card may take a moment to refresh.",
    "dailyLimitReached": "This customer reached today’s stamp limit for this shop."
  },
  "errors": {
    "generic": "Something went wrong.",
    "unauthorized": "Your session expired. Sign in again.",
    "forbidden": "You do not have permission for this action.",
    "network": "Check your connection and try again.",
    "validation": "Review the highlighted fields.",
    "idempotencyMismatch": "This retry does not match the original request.",
    "rateLimited": "Too many attempts. Try again later."
  },
  "language": {
    "english": "English",
    "traditionalChinese": "繁體中文",
    "german": "German",
    "choose": "Language",
    "current": "Language: {language}"
  },
  "demo": {
    "reward": {
      "freeDrink": "One drink up to €5"
    },
    "program": {
      "coffeeClub": "Coffee Club",
      "lunchCircle": "Lunch Circle"
    },
    "category": {
      "coffee": "Coffee",
      "food": "Food",
      "shops": "Shops"
    },
    "activity": {
      "earn": "Stamp earned",
      "bonus": "App Boost applied",
      "reward": "Reward unlocked",
      "redeem": "Reward redeemed"
    },
    "time": {
      "today1432": "Today · 14:32",
      "yesterday1208": "Yesterday · 12:08",
      "jul221744": "22 Jul · 17:44"
    }
  },
  "accessibility": {
    "stampCollected": "Collected stamp",
    "stampEmpty": "Uncollected stamp"
  },
  "official": {
    "meta": {
      "title": "Collectie — Turn visitors into regulars",
      "description": "A customer loyalty program for restaurants, retail and malls. Guests join in seconds from Apple Wallet — no app, no email, no personal data — so you can build lasting customer relationships while respecting their privacy.",
      "imageAlt": "Collectie helps restaurants, retail and malls turn first-time visitors into loyal regulars."
    },
    "analytics": {
      "label": "Optional analytics",
      "title": "Help us improve the website.",
      "body": "With your permission, Google Analytics measures page visits so we can improve this website. We never send form details, query strings, account data or advertising signals. Analytics stays off until you allow it.",
      "accept": "Allow analytics",
      "reject": "Keep analytics off",
      "privacy": "Read the privacy notice",
      "settings": "Analytics settings",
      "statusGranted": "Analytics is currently on.",
      "statusDenied": "Analytics is currently off."
    },
    "nav": {
      "product": "Loyalty",
      "platform": "Platform",
      "pricing": "Pricing",
      "contact": "Talk to us",
      "primary": "Primary navigation",
      "open": "Open menu",
      "close": "Close menu",
      "home": "Collectie home"
    },
    "hero": {
      "eyebrow": "Customer loyalty, built for every store",
      "titleLead": "Turn first-time guests",
      "titleAccent": "into loyal regulars.",
      "lede": "Collectie is a customer loyalty program for restaurants, cafés, retail and malls. Guests join in seconds from Apple Wallet — no app, no email, no personal details — so you build real relationships and repeat business while respecting their privacy.",
      "primary": "Explore loyalty",
      "secondary": "See the full platform",
      "artLabel": "A top-down operations map connecting the customer journey, floor, counter and back office",
      "artCore": "Your store",
      "artOrbit": "8 independent modules",
      "scroll": "Explore the platform"
    },
    "principle": {
      "eyebrow": "Loyalty first, everything else when you need it",
      "title": "Know your customers. Keep them coming back.",
      "body": "Start with a loyalty program any store can run in a day, then grow into ordering, payments, tables, inventory and more. Everything stays centered on one thing: understanding your customers and giving them a reason to return.",
      "keep": "Start in a day",
      "keepBody": "Launch a loyalty program for one location without replacing the systems you already use.",
      "hardware": "Understand your regulars",
      "hardwareBody": "See who comes back, how often and what they love — without ever holding their personal data.",
      "pace": "Manage by what you see",
      "paceBody": "Turn everyday visits into clear signals your team can act on to grow repeat business."
    },
    "restaurantScene": {
      "eyebrow": "Built around how a store really works",
      "title": "Every visit is a chance to build a relationship.",
      "body": "A guest walks in, orders, pays and leaves — and with Collectie, that visit quietly becomes part of a relationship. The same rhythm works whether you run a restaurant, a café or a shop in a mall, and your team keeps working the way they already do.",
      "guest": "Customers & floor",
      "kitchen": "Service & stock",
      "supply": "Receiving & supply",
      "alt": "Isometric pixel-art cutaway of a warm neighborhood restaurant during evening service, showing the dining room, counter, kitchen, inventory and a delivery arriving",
      "caption": "Illustration concept · a store built around its customers"
    },
    "loyalty": {
      "eyebrow": "First product · Loyalty",
      "title": "A loyalty program guests join in seconds — no personal data.",
      "body": "Customers scan your in-store QR code and add a Collectie card to Apple Wallet. No account, no app, no email or phone number. You grow a base of regulars without ever collecting personal data you would have to protect.",
      "wallet": "No app, no personal data",
      "walletBody": "Guests join straight from Apple Wallet — no email, phone number or account required.",
      "checkout": "One scan at checkout",
      "checkoutBody": "Your team scans the guest's card and confirms the visit. That is the whole interaction.",
      "truth": "Privacy built in",
      "truthBody": "Rewards are tracked against an anonymous card, not a person — nothing your customers would hesitate to share.",
      "cardProgram": "House regulars",
      "cardReward": "Next reward",
      "cardRewardValue": "House dessert",
      "cardProgress": "5 of 7 visits",
      "cardMember": "Member 284 916",
      "cardHint": "Scan at checkout",
      "flowJoin": "Join",
      "flowJoinBody": "Guest scans the restaurant QR code",
      "flowCollect": "Earn",
      "flowCollectBody": "Your team confirms the visit",
      "flowReturn": "Return",
      "flowReturnBody": "The reward brings them back"
    },
    "platform": {
      "eyebrow": "Grow at your own pace",
      "title": "Loyalty first. Add the rest when you're ready.",
      "body": "Begin with the loyalty program every store can use, then add ordering, payments, tables, inventory and suppliers over time. As they connect, each visit tells you a little more about your customers — so you can keep them coming back. Loyalty is available first; the modules below are planned.",
      "core": "Collectie Intelligence",
      "coreBody": "As modules connect, the AI-assisted core turns everyday activity into simple guidance — which regulars are slipping away, what to reorder, what to try next. It only advises; your team stays in control.",
      "intelligenceEyebrow": "AI-assisted platform core · Planned",
      "intelligenceMark": "AI",
      "intelligenceForecast": "Forecast demand",
      "intelligenceException": "Spot what's changing",
      "intelligenceAction": "Suggest next action",
      "intelligenceGuard": "Your team reviews and approves every important action.",
      "select": "Select a module to explore",
      "first": "Available first",
      "planned": "Planned",
      "pricingBasis": "Pricing basis",
      "loyalty": {
        "name": "Loyalty",
        "tagline": "Turn first-time visitors into regulars.",
        "body": "Apple Wallet membership, visit stamps and rewards — no customer app or personal data. You set the rules; your regulars do the rest.",
        "price": "Per active location"
      },
      "pos": {
        "name": "POS & Tap to Pay",
        "tagline": "Take payment on the device you already have.",
        "body": "Planned checkout for Tap to Pay, payments and receipts, connected to every customer visit.",
        "price": "Platform fee + payment usage"
      },
      "orders": {
        "name": "Orders",
        "tagline": "Keep every order in one place.",
        "body": "Planned order management for counter, table and online orders — restaurants and retail alike.",
        "price": "Per active location"
      },
      "tables": {
        "name": "Tables",
        "tagline": "See every table at a glance.",
        "body": "Planned live table status, guest counts and service handoffs for the floor team.",
        "price": "Per active location"
      },
      "reservations": {
        "name": "Reservations",
        "tagline": "Welcome guests before they arrive.",
        "body": "Planned reservations linked to visit history and notes, with privacy controls you keep in your hands.",
        "price": "Per bookable location"
      },
      "inventory": {
        "name": "Inventory",
        "tagline": "Know what's in stock before you promise it.",
        "body": "Planned stock and menu availability that updates with day-to-day activity.",
        "price": "Per stock location"
      },
      "supply": {
        "name": "Suppliers",
        "tagline": "Reorder from the right supplier at the right time.",
        "body": "Planned purchasing with low-stock alerts, supplier pricing, purchase orders and receiving.",
        "price": "By location and purchasing volume"
      },
      "invoice": {
        "name": "Invoices",
        "tagline": "Create compliant invoices from each sale.",
        "body": "Planned invoicing adapted to local rules and connected to checkout.",
        "price": "By jurisdiction and document volume"
      }
    },
    "pricing": {
      "eyebrow": "Simple, honest pricing",
      "title": "Start with loyalty. Pay only for what you use.",
      "body": "Launch the loyalty program first, then add modules when they earn their place. Each has its own clear pricing, so you never pay for what you are not using.",
      "loyaltyLabel": "Starting point",
      "loyaltyTitle": "Collectie Loyalty",
      "loyaltyBody": "Stores in our first local pilot get founding-partner terms. Public pricing will be announced later.",
      "includedOne": "Apple Wallet membership and permanent shop QR code",
      "includedTwo": "Staff scanner, rewards and visit history — no customer personal data",
      "includedThree": "Program setup for each active location",
      "founding": "Founding-partner pricing",
      "cta": "Talk about your store",
      "modelLabel": "How future modules are priced",
      "modelTitle": "Each module has its own pricing basis.",
      "modelBody": "Before you activate a module, you will see exactly how it is priced—for example by location, usage, payment volume or number of invoices.",
      "note": "The planned modules show our product roadmap. Their availability, features and pricing may change before release."
    },
    "contact": {
      "eyebrow": "Tell us about your store",
      "title": "Start with loyalty — or plan the whole platform.",
      "body": "Tell us what you would like to improve. We can show you the loyalty program today and talk through how the other modules could fit your restaurant, shop or mall over time.",
      "restaurant": "Store name",
      "restaurantPlaceholder": "e.g. Bar Flora",
      "email": "Work email",
      "emailPlaceholder": "you@yourstore.com",
      "city": "City",
      "cityPlaceholder": "Where are you based?",
      "interest": "What would you like to discuss?",
      "interestLoyalty": "Launch loyalty",
      "interestPlatform": "Explore the full platform",
      "interestPilot": "Join a local pilot",
      "submit": "Request a walkthrough",
      "submitting": "Sending request…",
      "privacy": "We use these details only to respond to your enquiry and automatically delete the lead after 180 days.",
      "privacyLink": "Read the privacy notice",
      "required": "Add your store name.",
      "restaurantTooLong": "Store name must be 120 characters or fewer.",
      "emailRequired": "Add your work email.",
      "emailInvalid": "Enter a valid email address.",
      "emailTooLong": "Keep the email address under 254 characters.",
      "cityRequired": "Add your city.",
      "cityTooLong": "Keep the city under 120 characters.",
      "submitError": "We could not save your request. Check your connection and try again.",
      "rateLimited": "Too many requests were sent from this connection. Please try again in one hour.",
      "readyTitle": "Request received.",
      "readyBody": "We saved your enquiry securely. The Collectie team can follow up at your work email.",
      "again": "Send another request"
    },
    "footer": {
      "statement": "Build lasting customer relationships — without collecting data you would have to protect.",
      "availability": "Loyalty available first · other modules in development",
      "privacy": "Privacy",
      "support": "Support",
      "terms": "Terms",
      "copyright": "© {year} Collectie"
    },
    "privacy": {
      "metaTitle": "Privacy — Collectie",
      "metaDescription": "How Collectie handles personal data across the app, Apple Wallet, merchant tools and website.",
      "skip": "Skip to the privacy notice",
      "eyebrow": "Privacy · EU/EEA and Taiwan",
      "title": "Your loyalty history belongs with you.",
      "lede": "This notice explains what Collectie collects, why we need it, who can receive it and the choices available to you.",
      "factsLabel": "Privacy notice details",
      "controllerLabel": "Controller",
      "controllerName": "Collectie",
      "updatedLabel": "Effective",
      "updatedDate": "26 August 2026",
      "contactLabel": "Privacy contact",
      "tocLabel": "In this notice",
      "summaryLabel": "The short version",
      "summaryBody": "Collectie does not sell personal data, run third-party advertising or track people across apps and websites. We use the minimum data needed to operate separate merchant rewards, secure accounts and update Apple Wallet passes.",
      "emailAction": "Ask a privacy question",
      "sections": {
        "scope": {
          "title": "Who and what this notice covers",
          "body": "Collectie is the controller for personal data handled through the Collectie customer app, Apple Wallet passes, public membership pages, merchant management and till tools, the official website, and support.",
          "coverage": "A participating merchant may separately control information it creates for its own loyalty terms, customer service, accounting or legal records. Ask that merchant about its own privacy practices when it decides how to use that information."
        },
        "data": {
          "title": "Data we handle",
          "intro": "The information involved depends on how you use Collectie:",
          "identity": "Membership and account data: opaque person, card and membership identifiers; display member code; language; and account, credential or pass status. A customer does not need to give an email address before receiving a Wallet pass.",
          "loyalty": "Loyalty activity: merchant and location membership, visits, purchases, progress, rewards, adjustments, reversals and expiry recorded in an immutable ledger. We do not capture a full basket by default; a purchase amount or item group is kept only when an approved loyalty rule requires it.",
          "wallet": "Apple Wallet data: pass type and serial identifiers, a protected pass authentication credential, device library identifier, Apple push token, and pass creation or update state.",
          "merchant": "Merchant operations data: authorised merchant user's name, work email, role, session and device information, plus merchant, location and loyalty-program configuration.",
          "technical": "Technical and security data: IP address and normal request metadata, request identifiers, device or app version, and security and diagnostic events. Credentials, one-time codes, Apple identity tokens and pass authentication credentials are redacted from application logs.",
          "support": "Support data: the contents of messages and attachments you choose to send us, together with the details needed to investigate the issue.",
          "website": "Website data: an enquiry includes restaurant name, work email, city, area of interest, interface language, submission time and delivery status. Abuse controls store only a keyed hash of the source IP, not the raw address. Separately, if you allow analytics, Google Analytics receives the page path and referrer without query strings or fragments, page title, interface language, normal browser and device information, IP address in transit, and a pseudonymous cookie identifier. Form contents and account identifiers are never sent to Analytics.",
          "minimization": "We do not collect payment-card details, health data, contacts or an advertising identifier for this service. Optional location access is used on your device to calculate distance and is not sent to Collectie's API."
        },
        "uses": {
          "title": "Why we use data",
          "intro": "Collectie uses personal data only for the following purposes:",
          "service": "Provide memberships, show server-owned balances, process verified earn and redemption activity, and display transaction history.",
          "wallet": "Create, sign, deliver and refresh Apple Wallet passes and notify registered devices when a pass is ready to update.",
          "security": "Authenticate users and merchant staff, prevent abuse and duplicate writes, investigate fraud, maintain audit trails and reconcile service failures.",
          "support": "Answer support requests, recover access where possible and respond to privacy-rights requests.",
          "contact": "Receive a website enquiry, notify the Collectie team and reply to the work email supplied by the restaurant. Website enquiries are not added to a marketing list without a separate lawful basis.",
          "legal": "Meet legal, accounting and regulatory obligations and establish, exercise or defend legal claims.",
          "improve": "Monitor reliability and improve the service using aggregated, low-cardinality operational measures—not advertising profiles. With consent, measure official-website page visits so we can understand which public information is useful."
        },
        "bases": {
          "title": "Legal bases",
          "intro": "For people in the EU or EEA, our legal basis depends on the activity:",
          "contract": "Contract: to provide the membership, Wallet pass, account or merchant service you request and to take requested steps before a contract.",
          "legitimate": "Legitimate interests: to secure and reliably operate Collectie, prevent misuse, support users and understand service performance, after balancing those needs against your rights.",
          "obligation": "Legal obligation: to retain or disclose records when applicable law, accounting rules or a valid authority request requires it.",
          "consent": "Consent: for optional website analytics, optional device location and any optional communication that requires consent. You can withdraw consent at any time without affecting earlier processing.",
          "taiwan": "In Taiwan, we process data for our contractual or similar relationship with you, with consent where required, and for necessary business purposes permitted by the Personal Data Protection Act. Necessary identifiers are required to create or recover an account and operate rewards; where browse-only access is offered, you can browse without creating an account."
        },
        "sharing": {
          "title": "Who receives data",
          "intro": "We disclose only what is needed for the service or required by law:",
          "merchants": "Participating merchants receive activity for their own customers and locations. A merchant cannot view another merchant's customer activity through Collectie.",
          "cloudflare": "Cloudflare provides our hosting, application runtime, database, object storage, queues and service email infrastructure.",
          "apple": "Apple provides the App Store, Apple Wallet, Apple Push Notification service and MapKit. Apple's own terms and privacy policy apply to its processing.",
          "google": "Google provides the optional Google Analytics service for the official website. The Analytics tag loads and receives a page view only after you allow analytics; Google advertising signals and personalisation remain disabled.",
          "law": "Authorities, advisers or affected parties may receive information when reasonably necessary to comply with law, protect people or the service, or handle a legal claim.",
          "change": "If Collectie is reorganised, financed, sold or merged, relevant information may be transferred with the business subject to appropriate protection and notice where required.",
          "noSale": "We do not sell or rent personal data, share it across merchants for advertising, or allow third-party advertising or cross-app tracking."
        },
        "transfers": {
          "title": "International transfers",
          "body": "Collectie uses global service providers. Our primary Cloudflare D1 database is configured for Western Europe, while Cloudflare, Apple and, when you consent to website analytics, Google may process or route data in other countries where they operate.",
          "safeguards": "Where a transfer from the EU or EEA requires a safeguard, we rely on an applicable adequacy decision, approved contractual protections or another lawful transfer mechanism. Contact us for more information about the relevant safeguards."
        },
        "retention": {
          "title": "How long we keep data",
          "intro": "We retain personal data only while it is needed for the service, security, dispute handling and applicable legal obligations. The period depends on the record and its purpose:",
          "active": "Active account, membership, credential and Wallet records are kept while you use the service or while needed to keep a membership working and secure.",
          "deletion": "When account deletion completes, Collectie revokes credentials, closes memberships and accounts, removes stored Wallet pass bundles, and pseudonymises direct account identifiers so they no longer identify the deleted user in normal operation.",
          "records": "Transaction, immutable ledger and audit records may be retained after deletion where needed to preserve balance integrity, prevent fraud, resolve disputes or meet legal obligations. We delete or anonymise them when those purposes no longer require them.",
          "support": "Support messages are kept until the request is resolved and for any additional period reasonably needed for security, disputes or legal compliance, then deleted or anonymised.",
          "analytics": "The website keeps your analytics choice until you change it or clear site data. If you allow analytics, Collectie's Google Analytics cookies expire no later than 90 days after they are first set and are not renewed on later page loads. Analytics event data follows the retention controls configured for the Analytics property and is deleted or anonymised when no longer needed.",
          "websiteLeads": "Website enquiries and their notification records are automatically deleted 180 days after submission. If an enquiry becomes a customer relationship, the necessary details move to the relevant customer record and its applicable retention rules."
        },
        "choices": {
          "title": "Your choices",
          "intro": "You can control several parts of the service:",
          "account": "Use browse-only access where offered, manage account details in the app, or start account deletion from Profile → Privacy and data.",
          "location": "Decline optional location access. Distance calculation will be unavailable, but your memberships and rewards will continue to work.",
          "wallet": "Remove a pass from Apple Wallet at any time. Removing a pass does not by itself delete your Collectie account or loyalty records; use the in-app deletion control or contact us for that.",
          "website": "The official website stores your selected language and analytics choice locally in your browser. Google Analytics remains off and its tag is not loaded until you allow it. Use Analytics settings in the footer to allow or withdraw analytics at any time; withdrawal removes Collectie Analytics cookies. Contact-form details are optional, and you may instead email support. You can clear local preferences in your browser settings.",
          "marketing": "Collectie does not currently send consumer marketing messages. If that changes, optional messages will include the consent and opt-out controls required by law."
        },
        "rights": {
          "title": "Your privacy rights",
          "intro": "Your rights depend on where you live and may be subject to legal exceptions:",
          "eu": "EU/EEA: you may ask for access, correction, erasure, restriction, portability or an objection; withdraw consent; and complain to your local data-protection authority.",
          "taiwan": "Taiwan: you may inquire about or review your data, request a copy, supplement or correct it, ask us to stop collection, processing or use, and request deletion, as provided by the Personal Data Protection Act.",
          "request": "Email contact@collectie.io to exercise a right. Describe the account or membership concerned and the request, but do not send passwords, one-time codes, raw QR or card credentials, pass authentication credentials, API keys or private keys. We may verify your identity before acting. EU/EEA requests are normally answered within one month; Taiwan requests are handled within the periods required by applicable law.",
          "complaint": "Please contact us first so we can investigate. You may also complain directly to the competent privacy or data-protection authority in your country or region."
        },
        "security": {
          "title": "How we protect data",
          "body": "We use transport encryption, role-based access, merchant-tenant separation, protected authentication credentials, idempotent transaction controls, immutable ledger records, audit events and log redaction. Access to production systems and signing material is restricted to authorised purposes.",
          "limits": "No internet service can guarantee absolute security. If you believe your Collectie account or data may be at risk, contact contact@collectie.io promptly and do not include credentials in the message."
        },
        "changes": {
          "title": "Changes and contact",
          "body": "We may update this notice when the service, providers or law changes. We will publish the updated notice here, revise the effective date and provide additional notice in the service when a change materially affects your privacy.",
          "contact": "For privacy questions or requests, email contact@collectie.io. Collectie is the company responsible for this notice."
        }
      }
    },
    "support": {
      "metaTitle": "Support — Collectie",
      "metaDescription": "Get help with Collectie memberships, rewards, Apple Wallet passes, accounts and merchant tools.",
      "skip": "Skip to Collectie support",
      "eyebrow": "Collectie support",
      "title": "Let’s get you back to your rewards.",
      "lede": "Help for customers using the Collectie app or Apple Wallet, and for merchant teams running loyalty at the till.",
      "contactKicker": "Contact us",
      "contactTitle": "Tell us what happened.",
      "contactBody": "Send one clear message with the context below. Use the support address for product problems and the privacy address for data-rights requests.",
      "emailLabel": "Product and account support",
      "privacyLabel": "Privacy requests",
      "safetyKicker": "Keep credentials private",
      "safetyTitle": "What never belongs in an email",
      "safetyBody": "Never send a password, one-time code, full QR or card credential, pass authentication credential, API key, signing certificate or private key. Collectie will never ask you to email these.",
      "prepareKicker": "Before you email",
      "prepareTitle": "Four details help us investigate faster.",
      "prepare": {
        "device": "Your device model, iOS or browser version, and Collectie app version if available.",
        "merchant": "The merchant and location involved, without sharing another person's information.",
        "time": "The approximate time, timezone and action you took just before the problem.",
        "screenshot": "A screenshot with member codes, QR codes, email addresses, tokens and other credentials covered or cropped out."
      },
      "topicsKicker": "Common topics",
      "topicsTitle": "Start with the right context.",
      "topics": {
        "wallet": {
          "title": "Apple Wallet pass",
          "body": "If a pass will not add or refresh, keep it installed, check your internet connection and tell us which merchant issued it. The server owns the balance; a temporarily stale pass does not change the underlying reward record."
        },
        "rewards": {
          "title": "Missing visit or reward",
          "body": "Tell us the merchant, location, approximate purchase time and what you expected to see. Rewards remain separate by merchant, and only the relevant merchant can confirm or reverse a purchase event."
        },
        "account": {
          "title": "New or lost device",
          "body": "Use the recovery path shown in the app. If access still fails, contact us before creating extra accounts so we can identify the safest available recovery option."
        },
        "deletion": {
          "title": "Delete your account",
          "body": "In the app, open Profile → Privacy and data → Delete account. If you cannot access the app, email support and state that you want account deletion; we will verify the request before acting."
        },
        "merchant": {
          "title": "Merchant till or management",
          "body": "For sign-in, one-time code, device pairing, revocation or reversal issues, include the merchant, location and device label—but never include the code, session credential or signing material."
        }
      },
      "responseKicker": "What happens next",
      "responseTitle": "A person will review the request.",
      "responseBody": "We aim to respond on business days as soon as we reasonably can. Privacy-rights requests follow the legal response periods described in our notice. For a suspected security issue, put “Security” in the subject line without including any credential.",
      "privacyAction": "Read the privacy notice"
    },
    "terms": {
      "metaTitle": "Terms — Collectie",
      "metaDescription": "The terms for using Collectie memberships, rewards, Apple Wallet passes, customer accounts and merchant tools.",
      "skip": "Skip to the terms",
      "eyebrow": "Terms · EU/EEA and Taiwan",
      "title": "Clear rules for collecting value.",
      "lede": "These terms govern your use of Collectie’s loyalty services, customer app, Apple Wallet passes, public membership pages and merchant tools.",
      "factsLabel": "Terms details",
      "providerLabel": "Service provider",
      "providerName": "Collectie",
      "updatedLabel": "Effective",
      "updatedDate": "18 August 2026",
      "contactLabel": "Support contact",
      "tocLabel": "In these terms",
      "summaryLabel": "The essential agreement",
      "summaryBody": "Collectie provides the technology that records merchant-specific loyalty activity. Each merchant controls its own program and remains responsible for its products, service and reward promises. Mandatory consumer rights always remain in place.",
      "emailAction": "Ask about these terms",
      "sections": {
        "agreement": {
          "title": "Agreement and eligibility",
          "body": "By accessing or using a Collectie service, you agree to these terms and our Privacy Notice. If you use merchant tools for an organisation, you confirm that you are authorised to act for it. If you do not agree, do not use the service.",
          "eligibility": "You may use Collectie only if you can lawfully enter this agreement. Where local law requires consent from a parent or guardian, you may use the service only with that consent."
        },
        "service": {
          "title": "What Collectie provides",
          "intro": "Collectie provides software and infrastructure for loyalty memberships:",
          "membership": "A public shop QR code can join or open a membership. It never proves a purchase or awards value by itself; an eligible transaction must be verified separately.",
          "separation": "Memberships, progress and rewards remain separate by merchant. They cannot be transferred, combined or redeemed with another merchant through Collectie.",
          "availability": "Features may differ by merchant, location, device, language or pilot stage. We may improve or replace features while preserving applicable rights and committed records.",
          "noPayment": "Unless a separate written service expressly says otherwise, Collectie Loyalty is not a payment service, bank account, stored-value product or point-of-sale system and does not hold your money."
        },
        "accounts": {
          "title": "Accounts and credentials",
          "intro": "You are responsible for using your account and credentials carefully:",
          "accuracy": "Provide accurate information when requested, keep it current and do not impersonate another person or create accounts to mislead a merchant or Collectie.",
          "security": "Protect your device, pass, account access and recovery information. Tell support promptly if you suspect loss, unauthorised access or misuse.",
          "devices": "A physical device is not your identity. Browser, Wallet, card and app records are credentials associated with a person and may be revoked or replaced for security.",
          "recovery": "Recovery depends on the verified information and credentials available. We may refuse or delay recovery when we cannot safely establish that the request is legitimate."
        },
        "rewards": {
          "title": "Visits, progress and rewards",
          "intro": "Merchant-specific program rules determine whether a transaction is eligible and how a reward works:",
          "merchantRules": "The merchant sets its earning, redemption, expiry, eligibility and availability rules and must make any additional conditions available to its customers.",
          "server": "Collectie’s server record is authoritative. An app screen or Wallet pass is a projection and may briefly be out of date while an update is delivered.",
          "corrections": "Eligible earn, bonus, redemption, expiry, adjustment and reversal activity is recorded as ledger entries. Mistakes are corrected with an auditable adjustment or reversal, not by silently deleting committed history.",
          "noValue": "Unless applicable law or a merchant’s express terms say otherwise, loyalty progress and rewards are promotional, have no cash value, earn no interest and cannot be sold or transferred."
        },
        "wallet": {
          "title": "Apple Wallet and the App Store",
          "body": "An Apple Wallet pass displays membership information supplied by Collectie. It is not an independent account or proof that a purchase occurred.",
          "apple": "Your download and use of the iOS app are also subject to applicable Apple App Store terms and Apple’s Standard End User License Agreement unless a custom EULA is provided in App Store Connect.",
          "updates": "Wallet updates require compatible Apple services, a supported device and network availability. A delayed visual update does not change the server-owned ledger record.",
          "removal": "Removing a Wallet pass does not automatically delete your Collectie account or loyalty history. Use the in-app account-deletion control or contact support if you want deletion."
        },
        "acceptable": {
          "title": "Acceptable use",
          "intro": "You must not misuse Collectie or help another person do so. In particular, you must not:",
          "law": "Use the service unlawfully or to violate another person’s rights.",
          "access": "Access an account, merchant, location, API, system or data without authorisation, or bypass a permission or security control.",
          "interference": "Disrupt, overload, probe, scrape or reverse engineer the service except to the limited extent applicable law expressly permits.",
          "fraud": "Forge or manipulate purchases, member codes, QR codes, passes, rewards, reversals or other loyalty activity.",
          "credentials": "Share passwords, one-time codes, raw card or QR credentials, pass authentication credentials, session tokens, API keys, certificates or private keys."
        },
        "content": {
          "title": "Content and intellectual property",
          "intro": "These terms do not transfer ownership of the service or third-party content:",
          "collectie": "Collectie and its licensors retain all rights in the software, design, brand and service materials. We grant you a limited, personal, revocable and non-transferable right to use the service as these terms allow.",
          "merchant": "Merchants retain responsibility for their names, logos, offers and program content. Their content may not be copied or used outside the service without the relevant owner’s permission.",
          "feedback": "If you voluntarily send product feedback, you allow Collectie to use it to operate and improve the service without an obligation to pay you. Do not include confidential information or another person’s personal data."
        },
        "merchants": {
          "title": "Participating merchants",
          "body": "Participating merchants are independent businesses. They—not Collectie—sell their goods and services, verify purchases, define their program rules, fulfil rewards, handle product complaints and comply with laws applying to their business.",
          "contract": "A separate merchant services agreement governs a merchant organisation’s use of Collectie and may contain commercial, support and data-processing terms. If it conflicts with these public terms for merchant use, the signed merchant agreement controls for that organisation."
        },
        "suspension": {
          "title": "Stopping or suspending service",
          "body": "Access may be restricted or suspended when reasonably necessary to protect users, merchants or Collectie, investigate suspected misuse, comply with law, address a security issue or respond to a material breach. Where appropriate, we will explain the reason and offer a way to contact us.",
          "user": "You may stop using Collectie at any time and may start account deletion from the app where available.",
          "collectie": "Collectie may discontinue a feature or the service with reasonable notice where practicable. Any refund or remedy required by mandatory law remains available.",
          "records": "Closure or suspension does not erase transaction, immutable ledger or audit records that must remain for balance integrity, security, disputes or legal obligations; our Privacy Notice explains how they are handled."
        },
        "disclaimers": {
          "title": "Service commitments and disclaimers",
          "body": "We will provide Collectie with reasonable care and skill. To the extent permitted by law, we do not promise that the service will always be uninterrupted, error-free or compatible with every device, or that a merchant will keep a program, product or reward available.",
          "mandatory": "Nothing in these terms excludes a warranty, guarantee, remedy or other consumer right that applicable law does not allow us to exclude."
        },
        "liability": {
          "title": "Responsibility for loss",
          "body": "Collectie is responsible for loss that is reasonably foreseeable and directly caused by our breach of these terms or failure to use reasonable care and skill, subject to the rules and remedies of applicable law.",
          "exclusions": "To the extent permitted by law, Collectie is not responsible for indirect or unforeseeable loss, merchant goods or services, merchant refusal to honour a reward, loss caused by your misuse or failure to protect credentials, or events outside our reasonable control.",
          "mandatory": "We do not exclude or limit liability where doing so would be unlawful, including liability for fraud, wilful misconduct, gross negligence where applicable, or death or personal injury caused by negligence. Mandatory consumer remedies remain unaffected."
        },
        "law": {
          "title": "Applicable law and disputes",
          "body": "These terms do not deprive consumers of mandatory protections available under the law of their country of habitual residence. A merchant organisation’s governing law and forum are set by its separate merchant agreement.",
          "resolution": "Contact support first so we can try to resolve the issue. You may still use any competent court, regulator, consumer body or dispute process available to you under applicable law; these terms do not require individual arbitration."
        },
        "changes": {
          "title": "Changes to these terms",
          "body": "We may update these terms for service, security, legal or operational changes. We will post the updated version, revise the effective date and give reasonable advance notice when a material change affects existing users, unless an urgent legal or security change requires faster action.",
          "continued": "The updated terms apply from their stated effective date. If you do not agree, you may stop using the service and request account deletion; rights and obligations that arose earlier remain in effect."
        },
        "contact": {
          "title": "Contact",
          "body": "Questions, complaints or notices about these terms can be sent to contact@collectie.io. Collectie is the company providing the service described here.",
          "privacy": "For information about personal data or to exercise a privacy right, read our Privacy Notice or email contact@collectie.io."
        }
      }
    },
    "legal": {
      "privacyTitle": "Privacy notice",
      "termsTitle": "Terms of service",
      "draft": "Local design draft",
      "notice": "This is draft content for design review. It requires legal review before publication.",
      "privacyBody": "This local preview does not send or store the contact form. Before collecting personal information, the public website must identify the operating entity, legal basis, service providers, retention periods, contact channel for data rights and any disclosures required in each market.",
      "termsBody": "This local preview does not create a merchant account, contract or service commitment. Before publication, legal counsel must approve the operating entity, services, pilot terms, payments, liability and governing law.",
      "back": "Back to the website"
    },
    "notFound": {
      "eyebrow": "404 · Table not found",
      "title": "We cannot find this page.",
      "body": "The address may have changed, or the page may not be available yet.",
      "back": "Return to Collectie"
    }
  },
  "app": {
    "title": "Get the Collectie app",
    "lede": "Your Wallet card keeps working. The app adds every shop's rewards in one place, your activity, and a safe way to move your card to a new phone.",
    "cardKeeps": "Keep using your Wallet card",
    "cardKeepsBody": "Nothing changes at the till: show the card, the shop scans it, your stamps update.",
    "comingSoonTitle": "Not on the App Store yet",
    "comingSoonBody": "The Collectie app is in pilot testing. Your rewards are saved to your card in the meantime.",
    "download": "Download on the App Store",
    "back": "Back to Collectie"
  }
}
